<template>
  <!--图片-->
  <lazy-component v-if="element.nodeName.toLowerCase()==='img'">
    <!-- lazy-load -->
    <van-image
      :src="src"
      @click="handleImageClick"
      @load="handleImageLoad"
    />
  </lazy-component>
  <!--其他dom元素-->
  <dom-element v-else :html="html">
    <template v-for="(childElement,i) in element.childNodes">
      <!--文本元素-->
      <template v-if="childElement.nodeName.toLowerCase()==='#text'">
        {{ childElement.data }}
      </template>
      <!--其他元素-->
      <template v-else>
        <content-element
          :key="i"
          :html="parseElementToHtml(childElement)"
          @click-image="handleImageClick"
          @load-image="handleImageLoad"
        />
      </template>
    </template>
  </dom-element>
</template>

<script>
import Vue from 'vue'
import Lazyload from 'vue-lazyload'
import DomElement from './DomElement'
import { parseHtmlToElements, parseElementsToHtml } from '@/utils'

Vue.use(Lazyload, {
  preLoad: 1.1,
  attempt: 1,
  lazyComponent: true
})

export default {
  name: 'ContentElement',
  components: {
    DomElement
  },
  props: {
    html: {
      type: String,
      required: true
    }
  },
  computed: {
    element() {
      return parseHtmlToElements(this.html)[0]
    },
    src() {
      if (this.element.attributes.src.nodeValue.startsWith('@')) {
        return process.env.VUE_APP_RECSS_BASE_API + this.element.attributes.src.nodeValue.substring(1)
      } else {
        return this.element.attributes.src.nodeValue
      }
    }
  },
  methods: {
    parseElementToHtml(element) {
      return parseElementsToHtml([element.cloneNode(true)])
    },
    handleImageClick(event) {
      this.$emit('click-image', event)
    },
    handleImageLoad(event) {
      if (event.target.getAttribute('lazy') === 'loaded') {
        this.$emit('load-image', event)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
